import { Directive, ElementRef, Renderer2, Signal, computed, effect, input } from '@angular/core';

@Directive({
    selector: '[libLineClamp]',
    standalone: false
})
export class LineClampDirective {
	private readonly defaultClampLines: number = 1;
	private readonly clampLinesCssClassName: string = 'w-typography-clamp-lines';

	public readonly enabled: Signal<boolean> = computed(() => {
		return this.libLineClamp() === false ? false : true;
	});

	public readonly libLineClamp = input<boolean | ''>();
	public readonly clampLines = input<number>();

	constructor(private readonly renderer: Renderer2, private readonly hostElement: ElementRef) {
		effect(() => {
			const enabled = this.enabled();
			const clampLines = this.clampLines();
			this.setClampStyles(enabled, clampLines);
		});
	}

	setClampStyles(enabled: boolean, clampLines: number | undefined): void {
		// webkit line clamp https://stackoverflow.com/questions/3404508/cross-browser-multi-line-text-overflow-with-ellipsis-appended-within-a-fixed-wid
		if (this.hostElement.nativeElement && enabled) {
			this.renderer.addClass(this.hostElement.nativeElement, this.clampLinesCssClassName);
			this.renderer.setStyle(
				this.hostElement.nativeElement,
				'-webkit-line-clamp',
				clampLines ?? this.defaultClampLines
			);
		} else {
			this.renderer.removeClass(this.hostElement.nativeElement, this.clampLinesCssClassName);
			this.renderer.removeStyle(this.hostElement.nativeElement, '-webkit-line-clamp');
		}
	}
}
